import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { ContentLinks, ContentFilter } from 'Blocks'
import { PAGE_CONTEXT as p, SCREEN_TYPE } from 'Constants'
import skins from './skins'
import { skin } from 'Utils'

const ContentHeaderLinks = props => {
  const getHeaderContent = () => {
    const {
      pageName,
      withContentLinks,
      title,
      intro,
      useButtons,
      screenType
    } = props
    switch (pageName) {
      case p.TREND_LIST:
      case p.INSTALOOK_LIST:
      case p.ARTICLE_LIST:
        return (
          <Fragment>
            <h1 className="list__title heading">{title}</h1>
            {intro && <h2 className="list__sub-title">{intro}</h2>}
            {withContentLinks && (
              <ContentLinks {...{ useButtons }} {...{ pageName }} />
            )}
          </Fragment>
        )
      case p.HOME_TRENDS:
      case p.HOME_INSTALOOKS:
      case p.HOME_ARTICLES:
        return (
          <Fragment>
            {<h2 className={`list__title`}>{title}</h2>}
            {screenType !== SCREEN_TYPE.SMALL && intro && (
              <h3 className={`list__sub-title`}>{intro}</h3>
            )}
            {withContentLinks && (
              <ContentLinks {...{ useButtons }} {...{ pageName }} />
            )}
          </Fragment>
        )
      default:
        return (
          <Fragment>
            <h2 className={`list__title content`}>{title}</h2>
            {intro && <h3 className={`list__sub-title`}>{intro}</h3>}
          </Fragment>
        )
    }
  }

  return (
    <div className={`content-header-links ${props.className}`}>
      {getHeaderContent()}
    </div>
  )
}

ContentHeaderLinks.propTypes = {
  className: PropTypes.any,
  intro: PropTypes.any,
  pageName: PropTypes.any,
  screenType: PropTypes.any,
  title: PropTypes.any,
  useButtons: PropTypes.any,
  withContentLinks: PropTypes.any
}

export default skin(ContentHeaderLinks, skins)
